import React, { useEffect, useState } from "react";
import { BlogEditorContainer } from "./styled";
import { useStructureStore } from "../../../optics/components/drawers/settings/features/org-chart/store/structure-store";
import { useOrgChartStore } from "../../../stores/use-org-chart-store";
import { addOrUpdateParentIdsInStructure } from "./structure-builder";
import ManualOrgChart from "../data/ManualOrgChart";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

function OrgChartEditor() {
  const [isInitialized, setIsInitialized] = useState(false);

  const {
    data: { structure: structureSavedInMacro, viewOptions },
  } = useOrgChartStore((state) => ({ data: state.data }));

  const { structure, setStructure, setLevelsWithUsers, getLevelsWithUsers } =
    useStructureStore((state) => ({
      structure: state.structure,
      setStructure: state.setStructure,
      setLevelsWithUsers: state.setLevelsWithUsers,
      getLevelsWithUsers: state.getLevelsWithUsers,
    }));

  useEffect(() => {
    if (!isInitialized && structureSavedInMacro) {
      const structureWithParentIds = addOrUpdateParentIdsInStructure(
        structureSavedInMacro
      );
      setStructure(structureWithParentIds);
      setIsInitialized(true);
    }
  }, [structureSavedInMacro, isInitialized, setStructure]);

  useEffect(() => {
    const levelsWithUsers = getLevelsWithUsers();
    setLevelsWithUsers([...levelsWithUsers]);
  }, [structure, setLevelsWithUsers, getLevelsWithUsers]);

  return (
    <DndProvider backend={HTML5Backend}>
      <BlogEditorContainer>
        <ManualOrgChart
          isPreview={false}
          structure={structure}
          viewOptions={viewOptions}
        />
      </BlogEditorContainer>
    </DndProvider>
  );
}

export default OrgChartEditor;
